export default "__VITE_ASSET__BlYB988b__"